<template>
  <div class="review">
    <FeedbackMeter class="mb-6" :amount="amount" :scale="0.8" />

    <h2 class="review-title">
      {{ reviewTitle }}
    </h2>

    <p class="review-info">
      {{ reviewInfo }}
    </p>

    <Button
      :href="buttonHref"
      :target="buttonTarget"
      class="mb-2 secondary inline-block"
      @click="onReviewClick"
    >
      {{ buttonLabel }}
      <v-icon
        v-if="!buttonText && amount > 3"
        slot="icon-end"
        name="shopify"
        class="shopify-icon"
        scale="1.1"
      />
    </Button>

    <p v-if="amount > 3" class="mb-0">
      <a
        class="review-help"
        href="http://help.promo.ai/article/how-to-submit-a-shopify-review-for-promo.ai/"
        target="_blank"
        @click="onHowToReviewClick"
      >
        (how do I leave a review?)
      </a>
    </p>
  </div>
</template>

<script>
import FeedbackMeter from "@/components/Feedback/FeedbackMeter";
import { getAccountId } from "@/lib/auth";

export default {
  name: "Review",
  components: { FeedbackMeter },
  props: {
    amount: {
      type: Number,
      default: 5,
    },
    buttonText: {
      type: String,
      default: "",
    },
    storeName: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      buttonHref:
        this.amount > 3
          ? "https://apps.shopify.com/promo-newsletters#modal-show=ReviewListingModal"
          : `mailto:support@promo.ai?subject=Promo Feedback&body=%0D%0A%0D%0A---%0D%0A%0D%0AStore: ${this.storeName} - ${this.amount}`,
      buttonLabel:
        this.buttonText || (this.amount > 3 ? "Review Now" : "Send Feedback"),
      buttonTarget: this.amount > 3 ? "_blank" : "_self",
      reviewInfo:
        this.amount > 3
          ? "If you're enjoying the product we'd be forever grateful if you could leave us a quick review on Shopify."
          : "We'd love to hear your thoughts and answer any questions you might have about Promo.",
    };
  },
  computed: {
    reviewTitle() {
      return this.title
        ? this.title
        : this.amount > 3
        ? "Amazing! Thank you!"
        : "Thank you for the feedback!";
    },
  },
  methods: {
    onReviewClick() {
      const event =
        this.amount > 3 ? "promo-review-click" : "promo-feedback-click";

      this.$gtm.trackEvent({
        event,
        accountId: getAccountId(),
      });

      this.$modal.hide("review");
    },
    onHowToReviewClick() {
      this.$gtm.trackEvent({
        event: "promo-how-to-review-click",
        accountId: getAccountId(),
      });
    },
  },
};
</script>

<style scoped>
.review {
  @apply px-8 py-6 max-w-sm mx-auto text-center;
  transform: rotate(-0.3deg);

  &.framed {
    @apply bg-brand-light border border-grey-lighter rounded-lg;
  }
}

.review-title {
  @apply text-support-light text-lg mb-3;

  @screen md {
    @apply text-xl;
  }
}

.review-info {
  @apply text-grey-darker text-sm leading-loose mb-5;
}

.review-help {
  @apply text-grey-dark font-mono;
  font-size: 11px;

  &:hover {
    @apply text-grey-darker;
  }
}

.shopify-icon {
  @apply ml-1 relative;
  top: 2px;
}
</style>
